"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApprovalHandler = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _state = require("../state");
var _chains = require("@blockwell/chains");
var _sourceUtil = require("../source-util");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _ethTypes = require("@blockwell/eth-types");
const erc20Handler = {
  type: "erc20",
  async checkApproval(values, requires, step, token, account, spender) {
    let decimalsSource = (0, _sourceUtil.createLiteralSource)(token.parameters.decimals);
    const [allowance, whenBelow, value] = await Promise.all([(0, _state.resolveBigNumberishSourcable)(values, [(0, _sourceUtil.createCallSource)("allowance", (0, _sourceUtil.createLiteralSource)(token.address), [account, spender])], step, _ethTypes.Typing.uint, decimalsSource).then(res => new _bignumber.default(res)), (0, _state.resolveBigNumberishSourcable)(values, [requires.whenBelow], step, _ethTypes.Typing.uint, decimalsSource), (0, _state.resolveBigNumberishSourcable)(values, [requires.value], step, _ethTypes.Typing.uint, decimalsSource)]);
    console.log("allowance", allowance.toString(10));
    if (whenBelow) {
      if (allowance.gte(whenBelow)) {
        return null;
      }
    } else if (allowance.gte(value)) {
      return null;
    }
    return {
      type: "erc20",
      chainId: (0, _chains.toChainId)(token.network),
      contractAddress: token.address,
      spender,
      value,
      account
    };
  }
};
const erc721AllHandler = {
  type: "erc721-all",
  async checkApproval(values, requires, step, token, account, spender) {
    const approved = await (0, _state.resolveBooleanSourcable)(values, [(0, _sourceUtil.createCallSource)("isApprovedForAll", (0, _sourceUtil.createLiteralSource)(token.address), [account, spender])], step);
    console.log("result for isApprovedForAll", token.address, account, spender, approved);
    if (approved === true) {
      return null;
    }
    return {
      type: "erc721-all",
      chainId: (0, _chains.toChainId)(token.network),
      contractAddress: token.address,
      spender,
      account
    };
  }
};
const erc721Handler = {
  type: "erc721",
  async checkApproval(values, requires, step, token, account, spender) {
    const tokenId = await (0, _state.resolveBigNumberishSourcable)(values, [requires.value], step);
    const operator = await (0, _state.resolveAddressSourcable)(values, [(0, _sourceUtil.createCallSource)("getApproved", (0, _sourceUtil.createLiteralSource)(token.address), [tokenId])], step);
    if ((0, _chains.addressEqual)(operator, spender)) {
      return null;
    }
    return {
      type: "erc721",
      chainId: (0, _chains.toChainId)(token.network),
      contractAddress: token.address,
      spender,
      tokenId,
      account
    };
  }
};
const stepSource = (0, _sourceUtil.createStepsSource)(1, "address");
class ApprovalHandler {
  constructor() {
    (0, _defineProperty2.default)(this, "api", null);
    (0, _defineProperty2.default)(this, "handler", async (state, args) => {
      const dumbapp = state.dumbapp;
      const requires = dumbapp.requiresApproval;
      if (requires) {
        const contract = args[0].contract;
        if (!contract) {
          return {
            success: false,
            code: "no_contract",
            message: "Could not find a contract for checking approvals, some input is probably missing."
          };
        }
        const chainId = args[0].chainId;
        const values = new _state.ExecutionStateValueProvider(state);
        const step = dumbapp.steps[0];
        const [token, spender] = await Promise.all([(0, _state.resolveAddressSourcable)(values, [requires.token], dumbapp.steps[0]).then(address => this.api.getContract({
          chainId,
          address
        })), (0, _state.resolveAddressSourcable)(values, [requires.spender, stepSource], step)]);
        if (!token) {
          return {
            success: false,
            code: "no_approval_token",
            message: "Could not find a token to check approval against."
          };
        }
        if (!spender) {
          return {
            success: false,
            code: "no_approval_spender",
            message: "Could not find a spender contract for approving."
          };
        }
        let handler;
        if (token.features.includes("erc20")) {
          console.log("using erc20 handler");
          handler = erc20Handler;
        } else if (token.features.includes("erc721")) {
          if (requires.value) {
            console.log("using erc721 handler");
            handler = erc721Handler;
          } else {
            console.log("using erc721-all handler");
            handler = erc721AllHandler;
          }
        }
        if (!handler) {
          return {
            success: false,
            code: "no_approval_handler",
            message: "No handler found for approving tokens, there may be a problem with the app configuration."
          };
        }
        let approve = await handler.checkApproval(values, requires, step, token, state.wallet.account, spender);
        let data = {
          approve,
          approvalContract: token
        };
        return {
          success: true,
          data
        };
      }
      return {
        success: true,
        data: {}
      };
    });
  }
  setApi(api) {
    this.api = api;
  }
}
exports.ApprovalHandler = ApprovalHandler;
//# sourceMappingURL=ApprovalHandler.js.map